import { captureException } from '@sentry/react';
import toast from 'react-hot-toast';

import { SendDocumentChannelsDialog } from '../../../customer/components/SendDocumentChannelsDialog';
import { sendCreditNote } from '../../models';
import type { CreditNoteDetail } from '../../endpoints/CreditNoteEndpoint.types';
import { getDisplayError } from '../../../../utils/get-display-error';
import { trackEvent } from '../../../../utils/track-event';
import { runPdfJobAndRefresh } from '../../../../utils/pdf-job-client';
import { PEPPOL_ALREADY_SENT_STATUSES } from '../../../peppol/peppol.types';
import { describePeppolAlreadySent } from '../../../peppol/peppol-status-labels';

export const SendCreditNoteDialog: React.FC<{
  creditNote: CreditNoteDetail;
  onSent?: () => Promise<void>;
}> = ({ creditNote, onSent }) => {
  return (
    <SendDocumentChannelsDialog
      triggerText="Verzend creditnota"
      title="Creditnota versturen"
      submitText="Verzend creditnota"
      customer={creditNote.customer}
      peppolAlreadySent={
        PEPPOL_ALREADY_SENT_STATUSES.includes(creditNote.peppol.status)
          ? describePeppolAlreadySent(creditNote.peppol)
          : undefined
      }
      onSubmit={async (options) => {
        try {
          await runPdfJobAndRefresh(await sendCreditNote(creditNote.id, options), onSent);
          trackEvent('creditnote_sent', { credit_note_id: creditNote.id });
          toast.success('Creditnota is verstuurd. Je krijgt een melding als er iets misgaat.');
        } catch (err) {
          captureException(err);
          toast.error(`Kon creditnota niet versturen: ${getDisplayError(err)}`);
          throw err;
        }
      }}
    />
  );
};
